export const drawMarker = (
    e,
    Add,
    addSelectType,
    setSitesetupDialogBox,
    setOurData,
    showTeeMarkers,
    setOpenModel,
    showPointsOfInterest
    ) => {
    if (Add) {
      if (addSelectType === 3) {
        if (e.y > window.innerHeight - 300) {
          e.y = window.innerHeight - 300;
        }
      } else {
        if (e.y > window.innerHeight - 450) {
          e.y = window.innerHeight - 450;
        }
      }
      if (e.x > window.innerWidth - 300) e.x = window.innerWidth - 350;
      let obj = {
        position: "fixed",
        top: 50 + e.y + "px",
        left: 110 + e.x + "px",
      };
      setSitesetupDialogBox(obj);
    }
    if (addSelectType === 4 && Add) {
      setOurData((prev) => ({
        ...prev,
        tee: [...prev.tee, { lat: e.lat, lng: e.lng }],
      }));
      showTeeMarkers.set(true);
      setOpenModel(true);
    } else if (addSelectType === 5 && Add) {
      setOurData((prev) => ({
        ...prev,
        poi: [...prev.poi, { lat: e.lat, lng: e.lng }],
      }));
      showPointsOfInterest.set(true);
      setOpenModel(true);
    } else if (addSelectType === 3 && Add) {
      setOurData((prev) => ({
        ...prev,
        cog: [...prev.cog, { lat: e.lat, lng: e.lng }],
      }));
      setOpenModel(true);
    }
  };